module.exports = __webpack_public_path__ + "img/australia_icc.27aa7d56.png";